<script>
  import Avatar from "../Avatar.svelte";
  import IconContainer from "../IconContainer.svelte";

  export let selectedOption = {};
  export let nSelected = 0;
  export let allSelectedText = "";
  export let allSelectedIcon = "allSelected";
  export let displayAllSelectedText = false;
  export let truncateLength = 0;

  $: displayLabel = truncateLength
    ? `${selectedOption.label.slice(0, truncateLength)}${selectedOption.label.length > truncateLength ? "..." : ""}`
    : selectedOption.label;
</script>

{#if displayAllSelectedText}
  {#if selectedOption.icon || selectedOption.image}
    <IconContainer icon={allSelectedIcon} size="sm" />
  {/if}
  {allSelectedText}
{:else}
  {#if selectedOption.image}
    <Avatar size="sm" image={selectedOption.image} />
  {:else if selectedOption.icon}
    <IconContainer icon={selectedOption.icon} size="sm" />
  {/if}
  {displayLabel}{nSelected > 1 ? ` + ${nSelected - 1}` : ""}
{/if}
